import { Column, Row, Typography } from 'components/ui/atoms';
import { useContext } from 'react';
import { LocalizationContext } from '../LocalizationContext/LocalizationContext';
import { useStyles } from './styles';

export const VersionSnackbar = ({ onClick }: { onClick: () => void }) => {
  const { dictionary } = useContext(LocalizationContext);
  const classes = useStyles();

  return (
    <Row spaceBetween alignCenter>
      <Column css={classes.clickable} gap={4} onClick={onClick}>
        <Typography color={(c) => c.monochrome[90]} variant="body.short" inline>
          {dictionary.newVersionAvailableDescription()}
        </Typography>
      </Column>
    </Row>
  );
};
